module.exports = __webpack_public_path__ + "dcab198d69a9dcc2f0c04e7d6fc53dd4.png";